var _defs, _path, _path2, _path3, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 319,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fiveseconds-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h191v146H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 0A84.5 84.5 0 1 1 161 84.5 84.5 84.5 0 0 1 245.5 0z",
    fill: "#d7eff3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.6 49.349a38 38 0 1 1-15.2 0v-5.858h-3.058a2 2 0 0 1-2.009-1.991v-4.509A2 2 0 0 1 235.342 35h21.316a2 2 0 0 1 2.009 1.991V41.5a2 2 0 0 1-2.009 1.991H253.6zm5.006 15.806c1.242.606 1.533 2.855.644 5.041l-7.9 18.811a3.947 3.947 0 1 1-7.074-3.45l9.96-17.806c1.172-2.039 3.131-3.2 4.37-2.596z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 8l93 161H11z",
    fill: "#feeccb",
    opacity: 0.999
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.5 62.6)",
    fill: "#f8f8f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.613 42.376H72v-2.857a12.284 12.284 0 0 0-12.27-12.27H45.107v-3.277a2.689 2.689 0 1 0-5.378 0v3.277H25.106a12.284 12.284 0 0 0-12.27 12.27v2.857H9.223A6.743 6.743 0 0 0 2.5 49.1v9.412a6.743 6.743 0 0 0 6.723 6.723h3.614v2.857a12.284 12.284 0 0 0 12.27 12.27H59.73A12.284 12.284 0 0 0 72 68.092v-2.857h3.614a6.743 6.743 0 0 0 6.723-6.723V49.1a6.743 6.743 0 0 0-6.724-6.724zm-66.39 17.48a1.416 1.416 0 0 1-1.429-1.429V49.1a1.416 1.416 0 0 1 1.429-1.429h3.614v12.185zM66.7 68.008a6.958 6.958 0 0 1-6.97 6.975H25.106a6.958 6.958 0 0 1-6.975-6.975V39.519a6.958 6.958 0 0 1 6.975-6.975H59.73a6.958 6.958 0 0 1 6.97 6.975zm10.337-9.5a1.416 1.416 0 0 1-1.429 1.429H72V47.671h3.614a1.416 1.416 0 0 1 1.429 1.429z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 5.546,
    r: 5.546,
    transform: "translate(26.283 40.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.546,
    cy: 5.546,
    r: 5.546,
    transform: "translate(47.46 40.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.83 57.419H33.006a1.877 1.877 0 0 0-1.849 2.353c.84 3.362 3.362 9.076 11.261 9.076s10.5-5.8 11.261-9.076a1.849 1.849 0 0 0-1.849-2.353zM42.418 15.821a2.708 2.708 0 0 0 2.689-2.689V8.089a2.689 2.689 0 0 0-5.378 0v5.126a2.692 2.692 0 0 0 2.689 2.606zM27.375 18.342l4.454 2.521a2.466 2.466 0 0 0 1.345.336 2.649 2.649 0 0 0 2.269-1.345 2.577 2.577 0 0 0-1.009-3.613L29.98 13.72a2.577 2.577 0 0 0-3.614 1.008 2.647 2.647 0 0 0 1.009 3.614zM51.747 21.199a2.661 2.661 0 0 0 1.345-.336l4.454-2.521a2.654 2.654 0 0 0-2.608-4.622l-4.454 2.521a2.723 2.723 0 0 0-1.008 3.614 2.484 2.484 0 0 0 2.271 1.344z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d2c2d0",
    d: "M162 169h150v150H162z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.194 270.508l-7.686 7.686a2.333 2.333 0 0 1-3.284 0l-7.942-7.942-6.032 6.009a2.293 2.293 0 0 1-2.049.652 2.334 2.334 0 0 1-1.7-1.281l-21.1-44.111a2.347 2.347 0 0 1 3.121-3.121l44.111 21.1a2.331 2.331 0 0 1 .629 3.75l-6.009 6.032 7.941 7.942a2.319 2.319 0 0 1 0 3.284zM213.648 217.354a2.33 2.33 0 0 0-3.294 3.294l5.754 5.754a2.329 2.329 0 0 0 3.293-3.293zM236.937 227.084a2.32 2.32 0 0 0 1.039-.246l7.671-3.836a2.33 2.33 0 0 0-2.083-4.167l-7.671 3.837a2.329 2.329 0 0 0 1.044 4.412zM218.797 241.851a2.327 2.327 0 0 0-3.125 1.042l-3.836 7.672a2.33 2.33 0 0 0 4.167 2.083l3.836-7.671a2.329 2.329 0 0 0-1.042-3.126zM228.806 223.2a2.353 2.353 0 0 0 .46.045 2.329 2.329 0 0 0 2.281-1.872l1.917-9.59a2.329 2.329 0 1 0-4.567-.914l-1.917 9.59a2.328 2.328 0 0 0 1.826 2.741zM216.2 235.806a2.326 2.326 0 0 0-2.741-1.826l-9.59 1.917a2.329 2.329 0 0 0 .455 4.613 2.355 2.355 0 0 0 .46-.045l9.59-1.917a2.328 2.328 0 0 0 1.826-2.742z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    d: "M192.5 288.5l89-89"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 146)",
    clipPath: "url(#fiveseconds-a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(161)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(184)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(23 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(46 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(69 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(92 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(115 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(138 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(161 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(184 23)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(23 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(46 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(69 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(92 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(115 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(138 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(161 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(184 46)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(23 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(46 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(69 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(92 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(115 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(138 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(161 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(184 69)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(23 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(46 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(69 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(92 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(115 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(138 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(161 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(184 92)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(23 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(46 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(69 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(92 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(115 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(138 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(161 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(184 115)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(23 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(46 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(69 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(92 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(115 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(138 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(161 138)",
    fill: "#88c0dd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(184 138)",
    fill: "#88c0dd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.70bb8440bd06f0733d81f66f41ebb281.svg";
export { ForwardRef as ReactComponent };